const colors = {
    light: '#fff',
    dark: '#002D3B',
    primary: '9ADBDA'
};

export default colors;